import * as React from 'react';

import { constantFormat, constantTable, getConstantQueryFetchPaged } from '../../../helpers/constants';
import { PagedList } from "../../../types/dataQueries/base/PagedList";
import { PDFNoteComment } from '../models/PDFNoteComment';
import { PDFNoteCommentQuery } from '../models/PDFNoteCommentQuery';
import { services } from "../../../services";
import { useBackgroundPromiseEffectByCondition } from '../../../helpers/hooks/useBackgroundPromiseEffectByCondition';
import { UserAvatar } from '../../../components/synced/ui/UserAvatar/UserAvatar';
import { EmptyState } from '../../../components/synced/ui/EmptyState/EmptyState';

interface NoteCommentsProps {
  noteId: number;
  onCommentsChanged: (count: number) => void;
}

export const NoteComments: React.FC<NoteCommentsProps> = ({ noteId, onCommentsChanged }) => {
  const [query, setQuery] = React.useState<PDFNoteCommentQuery>({
    ...getConstantQueryFetchPaged(),
    NoteIds: [noteId],
    NotForContractor: false,
  });
  // eslint-disable-next-line
  React.useEffect(() => setQuery(q => ({ ...q, NoteIds: [noteId], NotForContractor: false })), [noteId]);

  const [data, setData] = React.useState<PagedList<PDFNoteComment>>({ ...constantTable.initialPagedList });
  useBackgroundPromiseEffectByCondition(
    () => query.NoteIds.length > 0 && query.NoteIds[0] > 0,
    () => services.pDFNoteCommentService.fetchPaged(query),
    (res) => {
      setData(res);
      onCommentsChanged(res.TotalCount);
    },
    [query]
  );

  // раскомментировать когда бэкенд добавит /PDFNoteComments/save в CWebApi
  // const [promiseWrapper] = useBackgroundPromiseWrapper();
  // const [comment, setComment] = React.useState<string>('');
  // const EMPTY_EDITOR = '<p><br></p>';
  // const canSend = !!comment && comment !== EMPTY_EDITOR;
  // const onSaveComment = () => {
  //   promiseWrapper(
  //     () => {
  //       const res = services.pDFNoteCommentService.save([{
  //         Title: comment,
  //         NoteId: noteId,
  //         NotForContractor: false,
  //       }]);
  //       setComment('');
  //       return res;
  //     },
  //     (_res: PDFNoteComment[]) => setQuery(q => ({ ...q, NoteIds: [noteId] }))
  //   );
  // };

  const comments = data.Items ?? [];

  return (
    <div className="note-comments">
      {/* форма добавления комментария — ждём /PDFNoteComments/save в CWebApi
      <div className="note-comment-form">
        <div className="note-comment-form-label">Добавить комментарий</div>
        <EditorComponent
          value={comment}
          onTextChange={e => setComment(e.htmlValue ?? '')}
          style={{ height: '150px' }} />
        <div className="note-comment-send">
          <NewButton
            variant="primary"
            icon="fa-solid fa-paper-plane"
            disabled={!canSend}
            onClick={onSaveComment}>
            Отправить
          </NewButton>
        </div>
      </div>
      */}
      <div className="note-comment-list">
        <div className="note-comment-list-header">
          Комментарии
          {comments.length > 0 && <span className="note-comment-count">{comments.length}</span>}
        </div>
        {comments.length === 0 ? (
          <EmptyState
            icon="fa-comments"
            title="Нет комментариев" />
        ) : (
          comments.map((c, i) => (
            <div key={c.Id ?? i} className="note-comment-item">
              <div className="note-comment-head">
                <UserAvatar name={c.CreatedBy?.Title ?? '?'} size="sm" />
                <span className="note-comment-author">{c.CreatedBy?.Title ?? 'Пользователь'}</span>
                <span className="note-comment-date">{constantFormat.DateTimeToString(c.Created)}</span>
              </div>
              <div className="note-comment-body" dangerouslySetInnerHTML={{ __html: c.Title ?? '' }} />
            </div>
          ))
        )}
      </div>
    </div>
  );
};
